import styled, { css } from "styled-components";

import { COLOR, TEXT_COLOR } from "@sellernote/ui/src/sds-v2/styles/colors";
import { setFontStyle } from "@sellernote/ui/src/sds-v2/styles/typography";
import { mobile } from "@sellernote/ui/src/styles/functions";

import { fadeUpAnimation } from "../../../components/landing/index.styles";

const container = styled.section<{
  backgroundImageUrl: string;
}>`
  background: ${({ backgroundImageUrl }) => `url(${backgroundImageUrl})`};
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 300px;

  ${mobile(css`
    padding: 48px 24px;
    height: 340px;
    justify-content: flex-start;
    align-items: flex-start;
  `)}
`;

const content = styled.div`
  margin: 0 auto;
  width: 1128px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  ${fadeUpAnimation}

  .register-button {
    width: fit-content;
    animation-delay: 0.4s;
  }

  .mobile-only {
    display: none;
  }

  ${mobile(css`
    width: 100%;

    .mobile-only {
      display: initial;
    }
  `)}
`;

const title = styled.h3`
  ${setFontStyle("Head3")};
  color: ${TEXT_COLOR.white_1};
  animation-delay: 0.2s;

  em {
    color: ${COLOR.primary_200};
  }

  ${mobile(css`
    ${setFontStyle("Head6")};
  `)}
`;

export default {
  container,
  content,
  title,
};
